/**
 * Internal dependencies
 */
import SVGCurve1 from './images_1_15/curve-1.svg'
import SVGCurve1Shadow from './images_1_15/curve-1-shadow.svg'
import SVGCurve2 from './images_1_15/curve-2.svg'
import SVGCurve2Shadow from './images_1_15/curve-2-shadow.svg'
import SVGCurve3 from './images_1_15/curve-3.svg'
import SVGCurve3Shadow from './images_1_15/curve-3-shadow.svg'
import SVGRounded1 from './images_1_15/rounded-1.svg'
import SVGRounded1Shadow from './images_1_15/rounded-1-shadow.svg'
import SVGRounded2 from './images_1_15/rounded-2.svg'
import SVGRounded2Shadow from './images_1_15/rounded-2-shadow.svg'
import SVGSlant1 from './images_1_15/slant-1.svg'
import SVGSlant1Shadow from './images_1_15/slant-1-shadow.svg'
import SVGSlant2 from './images_1_15/slant-2.svg'
import SVGSlant2Shadow from './images_1_15/slant-2-shadow.svg'
import SVGWave1 from './images_1_15/wave-1.svg'
import SVGWave1Shadow from './images_1_15/wave-1-shadow.svg'
import SVGWave2 from './images_1_15/wave-2.svg'
import SVGWave2Shadow from './images_1_15/wave-2-shadow.svg'
import SVGWave3 from './images_1_15/wave-3.svg'
import SVGWave3Shadow from './images_1_15/wave-3-shadow.svg'

export const separators = {
	'wave-1': SVGWave1,
	'wave-2': SVGWave2,
	'wave-3': SVGWave3,
	'curve-1': SVGCurve1,
	'curve-2': SVGCurve2,
	'curve-3': SVGCurve3,
	'slant-1': SVGSlant1,
	'slant-2': SVGSlant2,
	'rounded-1': SVGRounded1,
	'rounded-2': SVGRounded2,
}

export const shadows = {
	'wave-1': SVGWave1Shadow,
	'wave-2': SVGWave2Shadow,
	'wave-3': SVGWave3Shadow,
	'curve-1': SVGCurve1Shadow,
	'curve-2': SVGCurve2Shadow,
	'curve-3': SVGCurve3Shadow,
	'slant-1': SVGSlant1Shadow,
	'slant-2': SVGSlant2Shadow,
	'rounded-1': SVGRounded1Shadow,
	'rounded-2': SVGRounded2Shadow,
}
